import axios from 'axios';
import { OriginalDecisionQpcInSnippet } from '../decision/decision.types';
import { LawPopoverInfos } from './legislation.types';

export async function getLegislationFromArticleId(
  articleId: string,
): Promise<LawPopoverInfos> {
  return (
    await axios.get('/getLawFromArticleId', {
      params: {
        articleId,
      },
    })
  ).data;
}

export async function getLawCardQPCDecisions(
  articleId: string,
): Promise<Array<OriginalDecisionQpcInSnippet>> {
  return (
    await axios.get('/getLawCardQPCDecisions', {
      params: {
        articleId,
      },
    })
  ).data.qpcDecisions;
}
